import { getScoreColor } from 'utils/ranking';

import _ from 'lodash';

import './FishbonePin.sass';

const sizes = { 1: 5, 2: 7, 3: 9 };

// Types
type FishbonePointProps = {
    trend: string;
    completion: number;
    weight: number;
    color: string;
};

export const FishbonePin = (props: FishbonePointProps) => {
    const color = getScoreColor(props.trend);

    // `weight` arrive parfois float (moyenne pondérée des items d'une branche)
    // ou grand entier — clamp sur la table de tailles {1, 2, 3} pour éviter
    // sizes[NaN/undefined] → r="NaN" qui masque toute la pastille.
    const safeWeight = Math.max(1, Math.min(3, Math.round(Number(props.weight) || 1)));
    const radius = sizes[safeWeight];

    // trend peut arriver string ('50') ou number (50). Coerce pour que le
    // mode "neutre" rouge/teal s'active dans les deux cas.
    const isNeutral = String(props.trend) === '50';

    let numberOfRaysMax = 39;
    let numberOfRays = Math.floor(
        ((props.completion || 0) / 100) * numberOfRaysMax
    );

    return (
        <g className="FishbonePin">
            <clipPath id="cut-off">
                <rect x="0" y="-9" width="18" height="18" />
            </clipPath>

            <circle
                r={radius}
                fill={isNeutral ? '#E70549' : color}
            />
            <circle
                r={radius}
                fill={isNeutral ? '#24CCB8' : color}
                clipPath="url(#cut-off)"
            />

            <circle className="mask" r={radius + 1} stroke="var(--ant-layout-body-bg)" strokeWidth={5} fill="none"></circle>

            {
                _.range(0, numberOfRays).map((r, index) => {
                    return (
                        <g
                            key={index}
                            className={'completion '}
                            transform={
                                'rotate(' +
                                ((index / numberOfRaysMax) * 360 - 90) +
                                ') '
                            }
                        >
                            <line
                                stroke="var(--ant-color-text-secondary)"
                                x1={12}
                                x2={15}
                                y1={0}
                                y2={0}
                            ></line>
                        </g>
                    );
                })
            } {' '}
        </g >
    );
};
